module.exports = __webpack_public_path__ + "src/assets/img/smoke_five.5a14dcc9.svg";